import { cn } from '../../lib/utils';

const ScoreRing = ({ score, size = 'md', showLabel = true, className }) => {
  const sizeConfig = {
    sm: { width: 48, stroke: 4, textSize: 'text-xs' },
    md: { width: 64, stroke: 5, textSize: 'text-sm' },
    lg: { width: 96, stroke: 6, textSize: 'text-lg' },
  };

  const config = sizeConfig[size];
  const radius = (config.width - config.stroke) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (score / 100) * circumference;

  let colorClass;
  if (score >= 85) colorClass = 'text-emerald-500';
  else if (score >= 70) colorClass = 'text-blue-500';
  else if (score >= 50) colorClass = 'text-amber-500';
  else colorClass = 'text-red-500';

  return (
    <div className={cn('relative inline-flex items-center justify-center', className)}>
      <svg
        width={config.width}
        height={config.width}
        className="transform -rotate-90"
      >
        <circle
          cx={config.width / 2}
          cy={config.width / 2}
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={config.stroke}
          className="text-slate-200"
        />
        <circle
          cx={config.width / 2}
          cy={config.width / 2}
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={config.stroke}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          className={cn(colorClass, 'transition-all duration-500')}
        />
      </svg>
      <div className={cn('absolute font-semibold', config.textSize, colorClass)}>
        {score?.toFixed(0)}
        {showLabel && <span className="text-slate-400">%</span>}
      </div>
    </div>
  );
};

export default ScoreRing;
